<template>
  <div class="timeline-heading">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'timeline-heading',
  props: {}
};
</script>

<style>
  .timeline-heading {
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
  }

  .timeline-heading p {
    margin-bottom: 5px;
  }

  .timeline-heading p.lead {
    margin-bottom: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/TimelineHeading.vue